// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../node_modules/modern-normalize/modern-normalize.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/images/icons/openEye.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --app-height: 100%;
}

#root {
  height: 100%;
  /* min-width: 1024px; */
}

html,
body {
  font-size: 13px;
  padding: 0;
  margin: 0;
  overflow: hidden;
  /* width: 100vw;
   */
  height: 100%;
  /* height: 100vh; */
  /* @media not all and (hover:hover) {
       height: var(--app-height);
   } */
}
.App {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  color: #426ba6;

  width: 100%;
  height: 100%;
  /* height: var(--app-height);     */
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.App button {
  color: #567db8;
  /* overflow-y: scroll; */
}
.App__container {
  width: 100%;
  /* max-width: 1980px;
  min-width: 1024px; */
  display: flex;
  justify-content: center;
  height: 100%;
  overflow-y: auto;

  /* padding-bottom: 4.2em; */

  /* overflow-x: scroll; */
}
.limitedSize {
  width: 100%;
  max-width: 1980px;
  margin-top: 4.5em;
  height: calc(100% - 4.5em);
  border: 6px solid #a3b9d9;
  border-top: 10px solid #a3b9d9;
  border-radius: 0px 15px 1px 1px;
  position: relative;
  flex-wrap: wrap;
  box-sizing: border-box;
  min-height: calc(576px - 4.2em);
}
.limitedSize__container {
  width: 100%;
  min-width: 1012px;
  position: relative;

  height: 100%;
  overflow-x: visible;
  padding: 0.5em 1.5em 0 1.5em;
}
.limitedSize_label {
  position: absolute;
  display: block;
  top: -2.5em;
  left: -6px;
  font-size: 1em;
  font-weight: 400;
  color: #426ba6;
  background-color: #a3b9d9;
  border-radius: 0px 25px 1px 0px;
  padding: 0 0.9em 0 1.1em;
  line-height: 1.5em;
}
.limitedSize__container.controlled {
  padding-bottom: 2.5em;
}
.overflow_container {
  height: 100%;
  width: 100%;
  position: relative;
  overflow-x: auto;
}

input {
  font-size: 1em;
}
input[type="checkbox"] {
  width: 1.2em;
  height: 1.2em;
}

/* @media screen and (min-width: 1805px) {
  .App{
    font-size: 15px;
    line-height: 18px;
  }
  .App table{
    font-size: 13px;
    line-height: 15px;
  }
  .error{
    font-size: 13px;
  }
} */
@media screen and (min-width: 1024px) {
  .App {
    font-size: 11px;
    line-height: 12px;
  }
  .App table {
    font-size: 11px;
    line-height: 12px;
  }
  .fixed_button {
    font-size: 11px;
  }
}

@media screen and (max-width: 1024px) {
  .App {
    font-size: 11px;
    line-height: 12px;
  }
  .App table {
    font-size: 11px;
    line-height: 12px;
  }
  .fixed_button {
    font-size: 11px;
  }
}
@media screen and (min-width: 1440px) {
  .App {
    font-size: 1rem;
    line-height: 1.1rem;
  }
  .App table {
    font-size: 1rem;
    line-height: 1.1rem;
  }
  .fixed_button {
    font-size: 1rem;
  }
}

@media screen and (min-width: 1905px) {
  .App {
    font-size: 1.2rem;
    line-height: 1.3rem;
  }
  .App table {
    font-size: 1.2rem;
    line-height: 1.3rem;
  }
  .fixed_button {
    font-size: 1.1rem;
  }
}
/* @media screen and (min-width: 3740px) {
  .App {
    font-size: 1.9rem;
    line-height: 2em;
  }
  .fixed_button{
    font-size: 1.7rem;
  }
  .App table {
    font-size: 1.8rem;
    line-height: 1.9rem;
  } */
/* .App .fieldWithSample input[type="checkbox"]{
    width: 2rem;
    height: 2rem;
  }
  .App input[type=checkbox]{
    width: 1.2em;
    height: 1.2em;
  }  */

/* } */

/* swal password styles*/
.swalPasswordWrapper {
  position: relative;
}

.swalPasswordInput {
  width: 100%;
  margin: 0;
  padding-right: 40px;
}

.swalShowPasswordBtn {
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 0;
  width: 30px;
  height: 30px;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  transition: transform 200ms ease-in-out;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});

  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;

  &:active {
    transform: translate(0px, 1px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/App/App.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;;EAEE,eAAe;EACf,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB;IACE;EACF,YAAY;EACZ,mBAAmB;EACnB;;MAEI;AACN;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;;EAEd,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX;sBACoB;EACpB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;;EAEhB,2BAA2B;;EAE3B,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;EAC1B,yBAAyB;EACzB,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;;EAElB,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,+BAA+B;EAC/B,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;;;;;;;;;;;;GAYG;AACH;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;;;;;;;;;;;KAWK;AACL;;;;;;;MAOM;;AAEN,MAAM;;AAEN,wBAAwB;AACxB;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,SAAS;EACT,eAAe;EACf,uCAAuC;EACvC,yDAAsD;;EAEtD,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;;EAExB;IACE,8BAA8B;EAChC;AACF","sourcesContent":["@import \"../../../node_modules/modern-normalize/modern-normalize.css\";\n\n:root {\n  --app-height: 100%;\n}\n\n#root {\n  height: 100%;\n  /* min-width: 1024px; */\n}\n\nhtml,\nbody {\n  font-size: 13px;\n  padding: 0;\n  margin: 0;\n  overflow: hidden;\n  /* width: 100vw;\n   */\n  height: 100%;\n  /* height: 100vh; */\n  /* @media not all and (hover:hover) {\n       height: var(--app-height);\n   } */\n}\n.App {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 13px;\n  color: #426ba6;\n\n  width: 100%;\n  height: 100%;\n  /* height: var(--app-height);     */\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n.App button {\n  color: #567db8;\n  /* overflow-y: scroll; */\n}\n.App__container {\n  width: 100%;\n  /* max-width: 1980px;\n  min-width: 1024px; */\n  display: flex;\n  justify-content: center;\n  height: 100%;\n  overflow-y: auto;\n\n  /* padding-bottom: 4.2em; */\n\n  /* overflow-x: scroll; */\n}\n.limitedSize {\n  width: 100%;\n  max-width: 1980px;\n  margin-top: 4.5em;\n  height: calc(100% - 4.5em);\n  border: 6px solid #a3b9d9;\n  border-top: 10px solid #a3b9d9;\n  border-radius: 0px 15px 1px 1px;\n  position: relative;\n  flex-wrap: wrap;\n  box-sizing: border-box;\n  min-height: calc(576px - 4.2em);\n}\n.limitedSize__container {\n  width: 100%;\n  min-width: 1012px;\n  position: relative;\n\n  height: 100%;\n  overflow-x: visible;\n  padding: 0.5em 1.5em 0 1.5em;\n}\n.limitedSize_label {\n  position: absolute;\n  display: block;\n  top: -2.5em;\n  left: -6px;\n  font-size: 1em;\n  font-weight: 400;\n  color: #426ba6;\n  background-color: #a3b9d9;\n  border-radius: 0px 25px 1px 0px;\n  padding: 0 0.9em 0 1.1em;\n  line-height: 1.5em;\n}\n.limitedSize__container.controlled {\n  padding-bottom: 2.5em;\n}\n.overflow_container {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  overflow-x: auto;\n}\n\ninput {\n  font-size: 1em;\n}\ninput[type=\"checkbox\"] {\n  width: 1.2em;\n  height: 1.2em;\n}\n\n/* @media screen and (min-width: 1805px) {\n  .App{\n    font-size: 15px;\n    line-height: 18px;\n  }\n  .App table{\n    font-size: 13px;\n    line-height: 15px;\n  }\n  .error{\n    font-size: 13px;\n  }\n} */\n@media screen and (min-width: 1024px) {\n  .App {\n    font-size: 11px;\n    line-height: 12px;\n  }\n  .App table {\n    font-size: 11px;\n    line-height: 12px;\n  }\n  .fixed_button {\n    font-size: 11px;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .App {\n    font-size: 11px;\n    line-height: 12px;\n  }\n  .App table {\n    font-size: 11px;\n    line-height: 12px;\n  }\n  .fixed_button {\n    font-size: 11px;\n  }\n}\n@media screen and (min-width: 1440px) {\n  .App {\n    font-size: 1rem;\n    line-height: 1.1rem;\n  }\n  .App table {\n    font-size: 1rem;\n    line-height: 1.1rem;\n  }\n  .fixed_button {\n    font-size: 1rem;\n  }\n}\n\n@media screen and (min-width: 1905px) {\n  .App {\n    font-size: 1.2rem;\n    line-height: 1.3rem;\n  }\n  .App table {\n    font-size: 1.2rem;\n    line-height: 1.3rem;\n  }\n  .fixed_button {\n    font-size: 1.1rem;\n  }\n}\n/* @media screen and (min-width: 3740px) {\n  .App {\n    font-size: 1.9rem;\n    line-height: 2em;\n  }\n  .fixed_button{\n    font-size: 1.7rem;\n  }\n  .App table {\n    font-size: 1.8rem;\n    line-height: 1.9rem;\n  } */\n/* .App .fieldWithSample input[type=\"checkbox\"]{\n    width: 2rem;\n    height: 2rem;\n  }\n  .App input[type=checkbox]{\n    width: 1.2em;\n    height: 1.2em;\n  }  */\n\n/* } */\n\n/* swal password styles*/\n.swalPasswordWrapper {\n  position: relative;\n}\n\n.swalPasswordInput {\n  width: 100%;\n  margin: 0;\n  padding-right: 40px;\n}\n\n.swalShowPasswordBtn {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n  transition: transform 200ms ease-in-out;\n  background-image: url(\"/src/images/icons/openEye.png\");\n\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n\n  &:active {\n    transform: translate(0px, 1px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
